import React from 'react'
import { Model } from './city_alpha'
import { Environment, Loader } from '@react-three/drei'
import PointsCameraSystem from './pointsCameraSystem'
import * as THREE from 'three'
import { Suspense } from 'react'

export default function App()
{

    const camRef = React.useRef()  
    
    return <>
    
    
       
    <Environment
        background={false}
        preset={'city'}
        backgroundIntensity={0}
        environmentIntensity={0.25}
    />
        
        <Model scale={[ 1, 1, 1 ]} />
        
        <PointsCameraSystem model={new Model()}/>
       
    
    <ambientLight 
        intensity={ 2 }
        color={new THREE.Color().setHex(0xf3fcff)} />

    </>
    

}